<template>
  <div>
    <section>

      <h3 class="text-center">สิทธิประโยชน์ของสมาชิกบีนีท</h3>

<pre>
  บีนีทเป็นผู้สร้างแพลตฟอร์มเทคโนโลยีเพื่อให้บริการต่างๆ เช่น บริการเกี่ยวกับบ้าน และ/หรือทำความสะอาดสำนักงาน บริการวางท่อประปา บริการระบบไฟฟ้า บริการทาสี บริการย้ายที่อยู่/ทำงาน รับจ้างทำงานเล็กๆ น้อยๆ หรืองานใดๆ ที่ปรากฏบนแพลตฟอร์มของบีนีทโดยบีนีทจะเป็นผู้จัดให้บริการบนบีนีทแฟลตฟอร์มซึ่งมีบริการที่หลากหลายตามแต่ความประสงค์ของลูกค้า
</pre>

<pre>
  บีนีทมีสิทธิพิเศษที่จะมอบให้แก่สมาชิกของบีนีทโดยเฉพาะเท่านั้น สมาชิกจะได้รับสิทธิพิเศษนับตั้งแต่จดทะเบียนสมัครสมัครและได้รับอนุมัติสถานภาพสมาชิกเป็นต้นไปโดยมีเสียค่าใช้จ่ายในการสมัคร 500 บาทซึ่งการเป็นสมาชิกจะมีสิทธิพิเศษดังนี้
1. มีสิทธิได้รับการพิจารณาคัดเลือกเป็นผู้ให้บริการอิสระของบีนีทตามเงื่อนไขข้อตกลงการเป็นผู้ให้บริการอิสระที่บีนีทกำหนด ทั้งนี้สมาชิกอาจได้รับคัดเลือกให้เป็นผู้ให้บริการของบีนีทหรือไม่ก็ได้
2. มีสิทธิในการเข้าอบรมการเป็นผู้ให้บริการอิสระของบีนีท ประเภทการบริการ
3. สมาชิกจะได้รับเครื่องแต่งกายที่แสดงถึงอัตลักษณ์ของบีนีท
4. มีสิทธิได้รับส่วนลดพิเศษในการซื้อผลิตภัณฑ์ของพันธมิตรต่างๆ บีนีท
5. มีสิทธิ์ในการซื้อผลิตภัณฑ์ของบีนีทในราคาสมาชิก พร้อมสิทธิในการผ่อนชําระด้วยดอกเบี้ย 0%
6. มีสิทธิได้รับการสะสมแต้มจากการซื้อผลิตภัณฑ์ของบีนีทเพื่อใช้เป็นส่วนลดพิเศษในการซื้อครั้งต่อไป
7. มีสิทธิ์เข้าร่วมกิจกรรมต่างๆ ที่บีนีทจัดขึ้นเพื่อสมาชิกโดยเฉพาะ
8. ได้รับการข่าวสารประชาสัมพันธ์ที่เป็นประโยชน์ต่างๆ จากบีนีทแพลตฟอร์ม
9. ในกรณีฉุกเฉินจําเป็น บีนีทอาจให้บริการสินเชื่อส่วนบุคคลให้แก่สมาชิก
10. สามารถใช้ wallet ของบีนีทบนบีนีทแพลตฟอร์มโดยไม่มีค่าใช้จ่าย (ระบบกําลังอยู่ระหว่างการดําเนินการ)

  ทั้งนี้ บริษัทขอสงวนสิทธิไม่สามารถเปลี่ยนส่วนเป็นเงินสด และเงื่อนไขในแต่ละโปรโมชั่นอาจมีความเปลี่ยนแปลงแล้วแต่กรณี
</pre>

    </section>
  </div>
</template>

<script>
export default {
  name: 'BenefitsDocument'
}
</script>

<style scoped>
section pre {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/professional/contract/BenefitsDocument.vue